// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__HDHfL","large":"styles_large__1udIi"};